module.exports = __webpack_public_path__ + "static/media/TrophyTeenPattiTest.38990b2f.svg";